export const links = {
  nav: {
    fontWeight: 400,
    color: "primary",
    cursor: "pointer",
  },
};
